import { render } from "./UserManDropDown.vue?vue&type=template&id=023f6d89&scoped=true"
import script from "./UserManDropDown.vue?vue&type=script&lang=js"
export * from "./UserManDropDown.vue?vue&type=script&lang=js"

import "./UserManDropDown.vue?vue&type=style&index=0&id=023f6d89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023f6d89"]])

export default __exports__